var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.printersUrl,"target":"_blank","rel":"noopener"}},[_c('LabelFunMessage',{attrs:{"fcontId":"0","msgkey":"29"}}),_vm._v(" » ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }